import { useWizard } from '../../../context/WizardContext';
import { ChapterSelect } from '../../../components/wizard/ChapterSelect';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';
import { useTranslation } from '../../../context/LanguageContext';

export function Step3Chapter() {
  const { state, toggleChapter } = useWizard();
  const { t } = useTranslation();
  const chapters = state.selectedPaper?.chapters ?? [];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">{t('wizard.chapterTitle')}</h2>
        <p className="text-sm text-slate-500 mt-1">
          {t('wizard.chapterSubtitle', {
            source: `${state.selectedSubject?.name ?? ''} — ${state.selectedPaper?.name ?? ''}`,
          })}
        </p>
      </div>
      <ChapterSelect
        chapters={chapters}
        selected={state.selectedChapters}
        onToggle={toggleChapter}
      />
      <NavigationButtons />
    </div>
  );
}
